<template>
  <div class="p-grid">
    <div class="p-lg-3 p-md-6 p-sm-12 p-field p-grid p-mb-0 p-ai-start">
      <label class="p-col-2 p-mt-2" for="org">{{ _t('label_orgs') }}</label>
      <div class="p-col-4">
        <MultiSelectableBreadcrumb :singleSelection="false" @change="setOrgId"></MultiSelectableBreadcrumb>
      </div>
    </div>
    <div class="p-lg-3 p-md-6 p-sm-12 p-field p-grid p-mb-0 p-ai-start">
      <label class="p-col-2 p-mt-2" for="title">{{ _t('specify_title') }}</label>
      <div class="p-col-4">
        <InputText id="title" v-model="title" :placeholder="_t('optional_title')" autocomplete="off"/>
      </div>
    </div>
    <div class="p-lg-3 p-md-6 p-sm-12 p-field p-grid p-mb-0 p-ai-start">
      <label class="p-col-2 p-mt-2" for="status">{{ _t('label_status') }}</label>
      <div class="p-col-4">
        <MultiSelect
            id="status"
            v-model="statuses"
            :options="alarmJobStatuses"
            :placeholder="_t('filter_statuses_filter')"
            :showClear="true"
            class="p-inputtext p-p-0 filter-input"
            display="chip"
            style="width: 10.8rem;"
        />
      </div>
    </div>
    <div class="p-lg-3 p-md-6 p-sm-12 p-field p-grid p-mb-0 p-ai-start">
      <label class="p-col-2 p-mt-2" for="name">{{ _t('label_Alarm_name') }}</label>
      <div class="p-col-4">
        <InputText id="name" v-model="name" :placeholder="_t('label_search_by_name')" class="filter-input"/>
      </div>
    </div>
    <div class="p-lg-3 p-md-6 p-sm-12 p-field p-grid p-mb-0 p-ai-start">
      <label class="p-col-2 p-mt-2" for="alarmPointId">{{ _t('label_alarm_id') }}</label>
      <div class="p-col-4">
        <InputText id="alarmPointId" v-model="alarmPointId" :placeholder="_t('label_search_by_alarm_point_ID')"
                   class="filter-input"/>
      </div>
    </div>
    <div class="p-lg-3 p-md-6 p-sm-12 p-field p-grid p-mb-0 p-ai-start">
      <label class="p-col-2 p-mt-2" for="systemId">{{ _t('label_system_id') }}</label>
      <div class="p-col-4">
        <InputText id="systemId" v-model="systemId" :placeholder="_t('label_search_by_system_ID')"
                   class="filter-input"/>
      </div>
    </div>
    <div class="p-lg-3 p-md-6 p-sm-12 p-field p-grid p-mb-0 p-ai-start">
      <label class="p-col-2 p-mt-2">{{ _t('label_started') }}</label>
      <div class="p-col-4">
        <ExtendedCalendar v-model:date="startedAt" :inputStyles="{width: 'auto'}" class="filter-input" orientation="left"/>
      </div>
    </div>
    <div class="p-lg-3 p-md-6 p-sm-12 p-field p-grid p-mb-0 p-ai-start">
      <label class="p-col-2 p-mt-2" for="lastHours">{{ _t('label_Last_hours') }}</label>
      <div class="p-col-4">
        <InputNumber id="lastHours" v-model="lastHours" :min="0" :placeholder="_t('label_Last_hours')"
                     class="filter-input"/>
      </div>
    </div>
    <div class="p-lg-3 p-md-6 p-sm-12 p-field p-grid p-mb-0 p-ai-start">
      <label class="p-col-2 p-mt-2" for="triggeredBy">{{ _t('filter_triggeredby') }}</label>
      <div class="p-col-4">
        <InputText id="triggeredBy" v-model="triggeredBy" :placeholder="_t('filter_triggeredby')" class="filter-input"/>
      </div>
    </div>
    <div class="p-col-12 p-field p-grid p-mb-0 p-ai-start">
      <label class="p-col-2 p-mt-2" for="participant">{{ _t('PARTICIPANTS') }}</label>
      <div class="p-col-4">
        <SelectParticipant id="participants" :multiple="true" class="participants"
                           filters-prefix="detailed_reports" @change="setParticipant"/>
      </div>
    </div>
  </div>
  <div style="margin-top: 1rem;">
    <Button :label="_t('label_Preview')" :loading="loading" class="p-button-success p-mr-2" @click="preview"/>
    <Button :loading="loading" class="p-button-success p-mr-2" icon="pi pi-file-excel"
            label="XLS" @click="download('xls')"/>
    <Button :loading="loading" class="p-button-success p-mr-2" icon="pi pi-file-pdf"
            label="PDF" @click="download('pdf')"/>
    <Button :loading="loading" class="p-button-success p-mr-2" icon="mdi mdi-email-edit-outline"
            label="Edit recipient" @click="editEmailDialog = true"/>
  </div>

  <Fieldset v-if="previewData.list.length" class="p-mt-4" legend="Preview">
    <DataTable
        :lazy="true"
        :page="currentPage"
        :paginator="true"
        :paginatorTemplate="'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink'"
        :rows="previewTableRows"
        :totalRecords="previewData.count"
        :value="previewData.list"
        class="p-datatable-sm"
        responsiveLayout="scroll"
        @page="selectTablePage($event)"
    >
      <template #paginatorstart>
        <div class="p-inputgroup" style="padding-top:10px;">
          <p class="p-inputgroup-addon" style="padding: 5px; font-size: 1rem;">
            {{ _t('primefaces.paginator.aria.ROWS_PER_PAGE') }}</p>
          <Dropdown v-model="previewTableRows"
                    :options="pageSize"
                    style="margin: 0px;"
          >
          </Dropdown>
        </div>
      </template>
      <Column :header="_t('label_status')" field="alarmJobStatus">
        <template #body="{ data }">
          <div class="p-d-flex">
            <div class="p-d-inline-flex p-mr-2" style="max-width:2rem;">
              <Button
                  :style="'background-color: ' + associateColor(data.jobStatusColor)"
                  style="max-height: 20px; right:20px; border: none; border-radius: 5px; margin:2px; display: inline-block;"
                  type="button"
              />
            </div>
            <div class="p-d-inline-flex p-mt-1">
              <strong class="truncate" style="max-width: 12rem;">
                {{ data.alarmJobStatus }}
              </strong>
            </div>
          </div>
        </template>
      </Column>
      <Column field="alarmPointStatus" header=""></Column>
      <Column :header="_t('label_Alarm_name')" field="alarmPointName"></Column>
      <Column :header="_t('filter_triggeredby')" field="triggeredBy"></Column>
      <Column :header="_t('label_alarm_id')" field="alarmPointId"></Column>
      <Column :header="_t('label_started')" field="alarmJobStartDate"></Column>
      <Column :header="_t('label_ended')" field="alarmJobEndDate"></Column>
      <Column :header="_t('label_system_id')" field="alarmPointSysId"></Column>
    </DataTable>
  </Fieldset>

  <Dialog v-model:visible="editEmailDialog" :closable="true" :modal="false" :style="{ width: '450px' }">
    <template #header>
      <h3>Edit recipient</h3>
    </template>

    <div class="p-grid p-formgrid p-fluid">
      <div class="p-col-12 p-field">
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">
            <i class="pi pi-pencil"></i>
          </span>
          <InputText
              id="email"
              v-model="emailRecipient"
              :class="{ 'p-invalid': emailTouched && !isEmailValid }"
              @blur="emailTouched = true"
              @input="emailTouched = true"
              placeholder="Enter your email"
          />
        </div>
      </div>
      <small v-if="emailTouched && !isEmailValid" class="p-error">
        {{ errorMessage }}
      </small>
    </div>

    <template #footer>
        <Button class="p-button-success p-button-outlined p-mr-2" label="Cancel" @click="editEmailDialog = false;" />
        <Button class="p-button-success" style="margin-right: 0;" label="Save" :disabled="!isEmailValid" @click="handleChangeRecipient" />
    </template>
  </Dialog>

  <Toast ref="toast" position="top-right">
    <template #message="{ message }">
      <div v-if="message.severity === 'success'">
        Recipient <strong>{{ message.emailRecipient }}</strong> was successfully saved
      </div>
    </template>
  </Toast>
</template>

<script>
import MultiSelectableBreadcrumb from "@/components/ixarma/MultiSelectableBreadcrumb";
import ExtendedCalendar from '@/components/ExtendedCalendar';
import SelectParticipant from "@/components/SelectParticipant";
import {mapGetters} from "vuex";
import {getDetailedReport} from "../../api/reports";
import {getHistory} from "../../api/alarmTable";
import {associateColor} from "@/service/helper/styleHelper";
import moment from "moment";
import { formatApiError } from "@/utils/apiError";
import { getOrganizationSnapshot } from "@/state/organizationContext";

function getSelectedReportOrgIds() {
  const {multiOrgIds, orgId} = getOrganizationSnapshot()
  return multiOrgIds.length ? multiOrgIds : [{id: orgId ?? 1}]
}

export default {
  name: 'report-detailed',
  components: {
    MultiSelectableBreadcrumb,
    ExtendedCalendar,
    SelectParticipant
  },
  data: () => ({
    orgIds: getSelectedReportOrgIds(),
    statuses: null,
    name: '',
    alarmPointId: "",
    systemId: null,
    startedAt: null,
    lastHours: 23,
    triggeredBy: null,
    participants: [],
    loading: false,
    alarmJobStatuses: ['NEW', 'CONFIG_PROBLEM', 'INACTIVE', 'FAILURE', 'FINISHED', 'INTERRUPTED',
      'CANCELED', 'NOT_ACCEPTED', 'NOT_ACKNOWLEDGED', 'PARTIAL_ACCEPTED', 'ACCEPTED',
      'PROCESSING', 'PARTIAL_ACKNOWLEDGED', 'ACKNOWLEDGED', 'SCHEDULED'
    ],
    title: '',
    previewData: {
      count: 0,
      currentPage: 0,
      list: [],
      pagesCount: 1,
    },
    currentPage: 0,
    previewTableRows: 20,
    pageSize: [5, 10, 20, 50],
    editEmailDialog: false,
    emailRecipient: '',
    emailTouched: false,
    monsterEmailRegex: new RegExp(
        `^(?:` +
        `[a-zA-Z0-9]+(?:[!#$%&'*+/=?^_\`{|}~-][a-zA-Z0-9]+)*` +
        `(?:\\.[a-zA-Z0-9]+(?:[!#$%&'*+/=?^_\`{|}~-][a-zA-Z0-9]+)*)*` +
        `|` +
        `"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*"` +
        `)` +
        `@` +
        `(?:` +
        `(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\\.)+` +
        `[a-zA-Z]{2,}` +
        `|` +
        `\\[` +
        `(?:` +
        `(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(?:\\.` +
        `(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}` +
        `|` +
        `[a-zA-Z0-9-]*[a-zA-Z0-9]:` +
        `(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])+` +
        `)` +
        `\\]` +
        `)$`
    ),
  }),
  watch: {
    previewTableRows() {
      this.currentPage = 0
      this.preview()
    },
    editEmailDialog(val) {
      if (val) this.emailTouched = false;

      if(!val) {
        this.emailRecipient = ''
      }
    }
  },
  methods: {
    associateColor,
    setOrgId: function (id) {
      this.orgIds = id
    },
    setParticipant() {
      this.participants = this.selectedParticipants
      localStorage.setItem('af.detailed_reports.participantsFilter', JSON.stringify(this.selectedParticipants))
    },
    buildQuery() {
      let duration =
          {
            start: this.startedAt?.start ? moment(this.startedAt.start).toDate() : null,
            end: this.startedAt?.end ? moment(this.startedAt.end).toDate() : null,
            option: this.startedAt?.start ? 'RANGE' : 'HOURS_DURATION',
            hours: this.lastHours
          }
      return {
        columnsFilter: {
          alarmName: this.name,
          alarmPointId: this.alarmPointId,
          statuses: this.statuses,
          systemId: this.systemId,
          triggeredBy: this.triggeredBy
        },
        currentPage: 0,
        duration: duration,
        name: this.title,
        orderByPriority: true,
        organizationFilter: this.orgIds.length ? this.orgIds : getSelectedReportOrgIds(),
        previewTableRows: 20,
        selectChildOrgs: getOrganizationSnapshot().withChildOrgs === true,
        participantsFilter: this.participants,
      };
    },
    selectTablePage(item) {
      this.loading = true
      this.currentPage = item.page
      this.preview();
    },
    preview() {
      const query = this.buildQuery();
      this.loading = true;
      return getHistory(
          this.currentPage,
          '',
          null,
          this.previewTableRows,
          query.columnsFilter,
          query.organizationFilter,
          query.duration,
          false,
          query.participantsFilter
      )
          .then(
              res => {
                if (res.status === 200) {
                  this.previewData = res.data;
                  this.loading = false;
                  return Promise.resolve(res.data)
                }
                return Promise.reject('Something went wrong');
              },
              error => {
                this.$toast.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: formatApiError(error, 'Something went wrong', ': '),
                  life: 3000
                });
              },
          )
          .finally(() => {
            this.loading = false;
          })
    },
    download(type = 'xls') {
      this.loading = true;
      return getDetailedReport(type, this.buildQuery())
          .then(
              res => {
                if (res.status === 200) {
                  var a = document.createElement("a");
                  document.body.appendChild(a);
                  a.style = "display: none";
                  const blob = new Blob([res.data], {type: 'xlsx'});
                  var url = window.URL.createObjectURL(blob);
                  a.href = url;
                  let headerLine = res.headers['content-disposition']
                  a.download = `${Date.now()}.${type}`
                  if (headerLine) {
                    a.download = headerLine.split('=').pop().replace('"', '')
                  }
                  a.click();
                  window.URL.revokeObjectURL(url);
                  this.loading = false;
                  return Promise.resolve();
                }
                return Promise.reject('Something went wrong');
              },
              error => {
                this.$toast.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: formatApiError(error, 'Something went wrong', ': '),
                  life: 3000
                });
              }
          )
          .finally(() => {
            this.loading = false;
          })
    },
    handleChangeRecipient() {
      this.$refs.toast.add({
        severity: 'success',
        life: 3000,
        emailRecipient: this.emailRecipient,
      });
    },
  },
  computed: {
    ...mapGetters({
      selectedParticipants: 'participant/getSelectedParticipants',
    }),
    isEmailValid() {
      if (!this.emailRecipient) return false;
      return this.monsterEmailRegex.test(this.emailRecipient.trim());
    },
    errorMessage() {
      if (!this.emailRecipient) return 'Email is required.';
      return 'Invalid email format.';
    },
  },
}
</script>

<style scoped>
.p-invalid {
  border-color: #f44336;
}
.p-error {
  color: #f44336;
  padding-left: 8px;
}
</style>

<style>
.participants .participant-list a {
  padding-left: 0!important;
}

.participants .participant-list .p-chip {
  margin-bottom: 0.5rem!important;
}
</style>
